import type { LocalizedText } from "../../api/CertRoadmap/types";

export type AnswerMap = {
  career_stage?: string;
  career_track: string[];
  specialization: string[];
  secondary_needs: string[];
  work_system?: string;
  foundation_gaps: string[];
  qualification?: string;
  eligibility_evidence: string[];
  completed_credentials: string[];
};

export type StepKey =
  | "career_stage"
  | "career_track"
  | "specialization"
  | "secondary_needs"
  | "work_system"
  | "foundation_gaps"
  | "qualification"
  | "eligibility_evidence"
  | "completed_credentials";

export type RoadmapView = "quiz" | "discover";

export type RoadmapLanguage = "en" | "ar";

export type VideoSegment = {
  start: number;
  end: number;
};

export type ActiveClip = {
  title: LocalizedText | string;
  code: string;
  segment: VideoSegment;
};

export const emptyAnswers = (): AnswerMap => ({
  career_track: [],
  specialization: [],
  secondary_needs: [],
  foundation_gaps: [],
  eligibility_evidence: [],
  completed_credentials: [],
});
